import React from 'react';
import { content } from '../data';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <section id="korekort" className="pt-12 pb-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16">
        <h2 className="text-3xl md:text-5xl font-semibold text-slate-900 uppercase text-center mb-4">
          Hvad tilbyder jeg?
        </h2>
      </div>

      <div className="space-y-12">
        {content.services.map((service, index) => (
          <motion.div 
            key={index} 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} bg-white items-center max-w-6xl mx-auto shadow-sm group`}
          >
            <div className="w-full md:w-2/5 overflow-hidden">
              <img 
                src={service.image} 
                alt={service.title} 
                className={`w-full h-64 md:h-80 object-cover transition-all duration-700 group-hover:scale-105 ${service.title === 'Personbil (Kategori B)' ? 'object-top' : ''}`}
              />
            </div>
            <div className="w-full md:w-3/5 flex flex-col justify-center px-8 md:px-12 py-12">
              <h3 className="text-2xl md:text-3xl font-semibold text-slate-900 uppercase mb-4">
                {service.title}
              </h3>
              <p className="text-slate-600 text-lg leading-relaxed mb-6">
                {service.description}
              </p>
              <div>
                <Link 
                  to="/kontakt" 
                  className="inline-block border-2 border-slate-900 text-slate-900 font-semibold uppercase tracking-widest px-6 py-3 rounded-full hover:bg-slate-900 hover:text-white transition-all text-sm"
                >
                  Læs mere
                </Link>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Services;
